import listenForReload from '../helpers/listen-for-reload';
import listenForScrollAnchor from '../helpers/listen-for-scroll-anchor';
import manageSubscriptionLink from '../helpers/manage-subscription-link';

function MyAccount () {
	this.tabs = document.querySelectorAll( '.hero__tab' );
	this.defaultTabId = 'personal-details';
	this.pianoInitialized = false;
	this.pianoTabs = {
		'personal-details': {
			containerSelector: '.personal-details .js-manage-my-account',
			loaderId: 'personal-details-loader',
		},
		'subscription-details': {
			containerSelector: '.subscription-details .js-manage-my-account',
			loaderId: 'subscription-details-loader',
		},
	};
	this.myAccountParamByTab = {
		'personal-details': 'pianoid',
		'subscription-details': 'library',
	};
}

MyAccount.prototype.init = function () {
	if ( document.querySelectorAll( '.page__my-account' ).length === 0 ) {
		return;
	}

	window.tp = window?.tp || [];

	this.initializePiano();

	this.setDefaultTab();
	manageSubscriptionLink();

	// Listens for Piano via postMessage
	listenForReload();
	listenForScrollAnchor();

	this.bindEvents();
};

MyAccount.prototype.scrollToAnchor = function ( anchor ) {
	const offsetY = 150;

	const scrollToPosition = () => {
		const elementRect = anchor.getBoundingClientRect();
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const topOffset = elementRect.top + scrollTop - offsetY;

		window.scrollTo( { top: topOffset, behavior: 'smooth' } );
	};

	requestAnimationFrame( scrollToPosition );
};

MyAccount.prototype.setDefaultTab = function () {
	const urlParams = new URLSearchParams( encodeURI( window.location.search ) );
	const tabParam = urlParams.get( 'tab' );
	const sectionParam = urlParams.get( 'section' );
	let currentTab =
		tabParam || sessionStorage.getItem( 'accountTab' ) || this.defaultTabId;

	if ( currentTab === 'contact-preferences' ) {
		currentTab = 'marketing-preferences';
	}

	const tabElement =
		document.querySelector( `.hero__tab[data-tab="${currentTab}"]` ) ||
		document.querySelector( `.hero__tab[data-tab="${this.defaultTabId}"]` );

	const isContactPreferencesTab = currentTab === 'marketing-preferences';
	const hasValidSection = isContactPreferencesTab && sectionParam;

	this.updateAccountSettingsTab(
		tabElement,
		hasValidSection ? sectionParam : null,
		'click',
	);

	// Manage contact-preferences sections
	if ( hasValidSection ) {
		const sectionElement = document.getElementById( sectionParam );
		if ( sectionElement ) {
			this.scrollToAnchor( sectionElement );
		}
	}
};

MyAccount.prototype.initializePiano = function () {
	if ( this.pianoInitialized ) {
		return;
	}

	this.pianoInitialized = true;

	window.tp = window.tp || [];
	window.tp.push( [
		'init',
		function () {
			const activeTab = sessionStorage.getItem( 'accountTab' ) || this.defaultTabId;
			if ( this.pianoTabs[ activeTab ] ) {
				this.renderPianoMyAccount( activeTab );
			}
		}.bind( this ),
	] );

	if ( window.userEntitlements ) {
		new window.userEntitlements( dataLayer ).buildUserContext( true );
	}
};

MyAccount.prototype.renderPianoMyAccount = function (
	activePianoTab = this.defaultTabId,
) {
	const pianoTab = this.pianoTabs[ activePianoTab ];

	if ( ! pianoTab ) {
		return;
	}

	const pianoReady = this.checkPianoReady();

	if ( ! pianoReady ) {
		return;
	}

	window.tp.pianoId.init( {
		profileUpdate ( data ) {
			window.tp.pianoId.loadExtendedUser( {
				formName: 'RegistrationFields',
				extendedUserLoaded ( extendedData ) {
					const field = extendedData.custom_field_values.find(
						x => x.field_name === 'registration_country',
					);

					let country = null;
					if ( field && typeof field.value === 'string' && field.value.trim() !== '' ) {
						try {
							const parsed = JSON.parse( field.value );
							if ( Array.isArray( parsed ) && parsed.length > 0 ) {
								country = parsed[ 0 ];
							}
						} catch ( e ) {
							country = field.value;
							console.warn( 'Log - Failed to parse registration_country field:', e );
						}
					}

					// Update profile via Aegis for server-side
					const pianoUserData = {
						email: extendedData.email,
						uid: extendedData.uid,
						country,
						first_name: extendedData.first_name,
						last_name: extendedData.last_name,
					};

					fetch(
						'/wp-json/ns-subscribers/v1/update-profile',
						{
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
								'X-Requested-with': 'XMLHttpRequest',
							},
							body: JSON.stringify( pianoUserData ),
						},
					).then( response => {
						if ( response.ok ) {
							console.debug( 'Log - profile updated successfully' );
						}
					} ).catch( error => {
						console.error( 'Log - profile update request failed:', error );
					} );
				},
			} );
		},
	} );

	window.tp.myaccount.show( {
		displayMode: 'inline',
		containerSelector: pianoTab.containerSelector,
		activateTemplateInteraction: true
	} );

	const loader = document.getElementById( pianoTab.loaderId );
	if ( loader ) {
		loader.style.display = 'none';
	}
};

MyAccount.prototype.checkPianoReady = () => {
	let intervalAttempts = 0;
	const maxIntervalAttempts = 10;

	const pianoReady = setInterval( () => {
		intervalAttempts ++;
		if ( window.tp.pianoId.init && window.tp.pianoId.loadExtendedUser && window.tp.myaccount.show ) {
			clearInterval( pianoReady );
			return true;
		}

		if ( intervalAttempts >= maxIntervalAttempts ) {
			clearInterval( pianoReady );
			return false;
		}
	}, 100 );

	return pianoReady;
};

MyAccount.prototype.updateAccountSettingsTab = function (
	li,
	section,
	event = false,
) {
	if ( ! li ) {
		return false;
	}

	Array.from( this.tabs ).forEach( el => {
		el.classList.remove( 'active' );
	} );

	li.classList.add( 'active' );

	const content = document.querySelectorAll(
		'.page__content[data-tab-content]',
	);

	const mainContent = li.dataset.tab;

	content.forEach( el => {
		if ( el.dataset.tabContent === mainContent ) {
			el.classList.add( 'active' );
		} else {
			el.classList.remove( 'active' );
		}
	} );


	if ( mainContent ) {
		sessionStorage.setItem( 'accountTab', mainContent );

		if ( history.pushState && event === 'click' ) {
			const url = new URL( window.location ); // phpcs:ignore WordPressVIPMinimum.JS.Window.location
			url.searchParams.set( 'tab', mainContent );
			const myAccountParam = this.myAccountParamByTab[ mainContent ];

			if ( myAccountParam ) {
				url.searchParams.set( 'myaccount', myAccountParam );
			} else {
				url.searchParams.delete( 'myaccount' );
			}

			// Remove the section parameter if there is no section
			if ( ! section ) {
				url.searchParams.delete( 'section' );
			}

			history.pushState( null, null, url.toString() );

			if ( this.pianoTabs[ mainContent ] && window.tp && window.tp.myaccount ) {
				this.renderPianoMyAccount( mainContent );
			}
		}
	}

	dataLayer.push( {
		event: 'widget_click',
		event_action: 'click',
		event_object_name: mainContent,
		event_object_type: 'Tab',
		event_type: 'Account management',
	} );

	return false;
};

MyAccount.prototype.bindEvents = function () {
	Array.prototype.forEach.call(
		this.tabs,
		function ( tab ) {
			tab.addEventListener(
				'click',
				function ( e ) {
					this.updateAccountSettingsTab( tab, null, 'click' );
				}.bind( this ),
			);
		}.bind( this ),
	);
};

window.addEventListener( 'DOMContentLoaded', function () {
	const myAccount = new MyAccount();
	myAccount.init();
} );
